<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <!--<button
          class="btn w-100 text-start"
          v-on:click="active = 'basic'"
          :class="active === 'basic' ? 'btn-primary' : 'btn-simple'"
        >
          Customer center
        </button>-->
        <button
          class="btn w-100 text-start"
          v-on:click="active = 'help'"
          :class="active === 'help' ? 'btn-primary' : 'btn-simple'"
        >
          Help
        </button>
        <button
          class="btn w-100 text-start"
          v-on:click="active = 'return'"
          :class="active === 'return' ? 'btn-primary' : 'btn-simple'"
        >
          Return
        </button>
        <button
          class="btn w-100 text-start"
          v-on:click="active = 'deliveries'"
          :class="active === 'deliveries' ? 'btn-primary' : 'btn-simple'"
        >
          {{ $t("countries.deliveries") }}
        </button>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10">
      <div v-if="active === 'help'">
        <h2>Help</h2>
        <p>This is the help section for returns.</p>
      </div>
      <section v-else-if="active == 'basic'">
        <h3 class="mb-3 bold-19">Customer support menu items</h3>
        <OneByOneTable
          v-model:rows="customerMenuRows"
          v-model:items="customerMenuItems"
          type="Menu"
          :show-add="false"
          :show-edit="false"
          :show-del="false"
        />
      </section>
      <section v-else-if="active == 'return'">
        <h3 class="mb-3 bold-19">Return</h3>
        <div
          v-if="!languages || languages.length === 0"
          class="alert alert-info"
        >
          Loading languages and settings...
          <div v-if="activeCountries && activeCountries.length > 0">
            Countries loaded: {{ activeCountries.length }}
          </div>
          <div v-else>Waiting for countries data...</div>
        </div>
        <div
          v-else
          class="text-start custom-input whitebg-input row align-items-center"
        >
          <label class="form-label bold-12 text-gray col-8">
            Allow self-serve return service
          </label>
          <div class="col-4 mb-5">
            <label class="cstm-check d-flex" for="ct-1">
              <input
                type="checkbox"
                v-model="is_self_serve_return"
                :true-value="1"
                :false-value="0"
                id="ct-1"
                @change="saveSettings"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <label class="form-label bold-12 text-gray col-8">
            Allow shop return service
          </label>
          <div class="col-4 mb-5">
            <label class="cstm-check d-flex" for="ct-2">
              <input
                type="checkbox"
                v-model="is_shop_return"
                :true-value="1"
                :false-value="0"
                id="ct-2"
                @change="saveSettings"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <label class="form-label bold-12 text-gray col-8">
            Cancel Return if the parcel is not returned within this period
          </label>
          <div class="fix-end-input col-4">
            <input
              type="number"
              class="form-control"
              v-model="delete_return_delivery_days"
              ref="imp"
              step="1"
              :min="1"
              @change="saveSettings"
            />
            <span>days</span>
          </div>
        </div>
        <h3 class="mb-3 bold-19">Return form</h3>
        <div class="row align-self-start">
          <div
            class="col-auto p-0 m-0 mb-3"
            v-for="l in languages"
            :key="l.code"
          >
            <button
              class="btn btn-tab"
              :class="{ active: l.code === selectedLanguage }"
              v-on:click="selectedLanguage = l.code"
            >
              <span class="semibold-14">{{ l.name }}</span>
            </button>
          </div>
        </div>
        <div class="mb-5">
          <OneByOneTable
            :rows="returnFormQuestionRows"
            :items="returnFormQuestionItems"
            type="Question"
            :show-add="true"
            :show-edit="true"
            :show-del="true"
            @addbtn="openAddQuestion"
            @edit="editQuestionById"
            @deleteEvent="deleteQuestionById"
          />
        </div>
      </section>
      <section v-if="active == 'deliveries'">
        <div v-if="activeCountries && activeCountries.length > 0">
          <h3 class="mb-3 bold-19">Full return</h3>
          <div>
            <h4 class="mb-3 bold-16">EU</h4>
            <label class="cstm-check d-flex gap-2 mb-3">
              <span class="text-black mx-2 regular-14">
                <span class="d-block bold-16"
                  >Full Refund of Transport Costs</span
                >
                <span class="d-block">
                  The customer is reimbursed for the entire transport cost
                  incurred during the purchase.
                </span>
              </span>
              <input
                type="radio"
                v-model="euType"
                :value="1"
                @change="saveSettings"
              /><span class="checkmark"></span>
            </label>
            <label class="cstm-check d-flex gap-2 mb-3">
              <span class="text-black mx-2 regular-14">
                <span class="d-block bold-16"
                  >Refund of the Cheapest Transport Cost</span
                >
                <span class="d-block">
                  The customer is refunded an amount equivalent to the lowest
                  available transport option, regardless of the method they
                  originally selected.
                </span>
                <span class="d-block">
                  The Consumer Rights Directive states businesses only need to
                  refund standard delivery costs, even if customers choose
                  non-standard, more expensive methods.
                </span>
              </span>
              <input
                type="radio"
                v-model="euType"
                :value="2"
                @change="saveSettings"
              /><span class="checkmark"></span>
            </label>
            <label class="cstm-check d-flex gap-2 mb-3">
              <span class="text-black mx-2 regular-14">
                <span class="d-block bold-16"
                  >No Refund of the Transport Cost</span
                >
                <span class="d-block">
                  The customer bears the full transport cost, and no refund is
                  provided.
                </span>
                <span class="d-block">
                  <b>Warning</b>: No refund is allowed only for special products
                  like custom-made or perishable goods (Article 16, EU
                  Directive).
                </span>
              </span>
              <input
                type="radio"
                v-model="euType"
                :value="0"
                @change="saveSettings"
              /><span class="checkmark"></span>
            </label>
          </div>
          <div>
            <h3 class="mb-3 bold-16">Other countries</h3>
            <div class="row mb-3 bold-16">
              <div class="col-3">Country</div>
              <div class="col-3 text-center">Full refund</div>
              <div class="col-3 text-center">Cheapest refund</div>
              <div class="col-3 text-center">No Refund</div>
            </div>
            <div
              v-for="country in exportCountries"
              :key="country.id"
              class="row mb-1"
            >
              <div class="col-3">
                {{ country.name }}
              </div>
              <div class="col-3 justify-content-center d-flex">
                <label
                  class="cstm-check"
                  v-if="taxSettings && taxSettings[country.id]"
                >
                  <input
                    type="radio"
                    v-model="taxSettings[country.id].return_mode"
                    :value="1"
                    @change="saveSettings"
                  /><span class="checkmark"></span>
                </label>
              </div>
              <div class="col-3 justify-content-center d-flex">
                <label
                  class="cstm-check"
                  v-if="taxSettings && taxSettings[country.id]"
                >
                  <input
                    type="radio"
                    v-model="taxSettings[country.id].return_mode"
                    :value="2"
                    @change="saveSettings"
                  /><span class="checkmark"></span>
                </label>
              </div>
              <div class="col-3 justify-content-center d-flex">
                <label
                  class="cstm-check"
                  v-if="taxSettings && taxSettings[country.id]"
                >
                  <input
                    type="radio"
                    v-model="taxSettings[country.id].return_mode"
                    :value="0"
                    @change="saveSettings"
                  /><span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5">
          <h3 class="mb-3 bold-19">Partial return</h3>
          <div>
            <h4 class="mb-3 bold-16">EU</h4>
            <label class="cstm-check d-flex gap-2 mb-3">
              <span class="text-black mx-2 regular-14">
                <span class="d-block bold-16"
                  >Full Refund of Transport Costs</span
                >
                <span class="d-block">
                  The customer is reimbursed for the entire transport cost
                  incurred during the purchase.
                </span>
              </span>
              <input
                type="radio"
                v-model="partialEuType"
                :value="1"
                @change="saveSettings"
              /><span class="checkmark"></span>
            </label>
            <label class="cstm-check d-flex gap-2 mb-3">
              <span class="text-black mx-2 regular-14">
                <span class="d-block bold-16"
                  >Refund of the Cheapest Transport Cost</span
                >
                <span class="d-block">
                  The customer is refunded an amount equivalent to the lowest
                  available transport option, regardless of the method they
                  originally selected.
                </span>
                <span class="d-block">
                  The Consumer Rights Directive states businesses only need to
                  refund standard delivery costs, even if customers choose
                  non-standard, more expensive methods.
                </span>
              </span>
              <input
                type="radio"
                v-model="partialEuType"
                :value="2"
                @change="saveSettings"
              /><span class="checkmark"></span>
            </label>
            <label class="cstm-check d-flex gap-2 mb-3">
              <span class="text-black mx-2 regular-14">
                <span class="d-block bold-16"
                  >No Refund of the Transport Cost</span
                >
                <span class="d-block">
                  The customer bears the full transport cost, and no refund is
                  provided.
                </span>
                <span class="d-block">
                  In cases where the return does not involve withdrawal from the
                  contract, the EU does not mandate transport cost
                  reimbursement.
                </span>
              </span>
              <input
                type="radio"
                v-model="partialEuType"
                :value="0"
                @change="saveSettings"
              /><span class="checkmark"></span>
            </label>
          </div>
          <div>
            <h3 class="mb-3 bold-16">Other countries</h3>
            <div class="row mb-3 bold-16">
              <div class="col-3">Country</div>
              <div class="col-3 text-center">Full refund</div>
              <div class="col-3 text-center">Cheapest refund</div>
              <div class="col-3 text-center">No Refund</div>
            </div>
            <div
              v-for="country in exportCountries"
              :key="country.id"
              class="row mb-1"
            >
              <div class="col-3">
                {{ country.name }}
              </div>
              <div class="col-3 justify-content-center d-flex">
                <label
                  class="cstm-check"
                  v-if="taxSettings && taxSettings[country.id]"
                >
                  <input
                    type="radio"
                    v-model="taxSettings[country.id].partial_return_mode"
                    :value="1"
                    @change="saveSettings"
                  /><span class="checkmark"></span>
                </label>
              </div>
              <div class="col-3 justify-content-center d-flex">
                <label
                  class="cstm-check"
                  v-if="taxSettings && taxSettings[country.id]"
                >
                  <input
                    type="radio"
                    v-model="taxSettings[country.id].partial_return_mode"
                    :value="2"
                    @change="saveSettings"
                  /><span class="checkmark"></span>
                </label>
              </div>
              <div class="col-3 justify-content-center d-flex">
                <label
                  class="cstm-check"
                  v-if="taxSettings && taxSettings[country.id]"
                >
                  <input
                    type="radio"
                    v-model="taxSettings[country.id].partial_return_mode"
                    :value="0"
                    @change="saveSettings"
                  /><span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Add Question Modal -->
    <div
      v-if="showAddQuestion"
      class="modal-backdrop d-block"
      style="background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal d-block" tabindex="-1">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ editingQuestionId ? "Edit" : "Add" }} Return Form Question
              </h5>
              <button
                type="button"
                class="btn-close"
                @click="showAddQuestion = false"
              ></button>
            </div>
            <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
              <div class="row row-tabs mb-3">
                <div
                  class="col-auto p-0 m-0"
                  v-for="l in languages"
                  :key="l.code"
                >
                  <button
                    class="btn btn-tab"
                    :class="{ active: l.code === selectedLanguage }"
                    v-on:click="selectedLanguage = l.code"
                  >
                    <span class="semibold-14">{{ l.name }}</span>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Type</label>
                  <select v-model="newQuestion.type" class="form-select">
                    <option value="fillable">Fillable (Text)</option>
                    <option value="selectable">Selectable (Dropdown)</option>
                  </select>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label d-block">&nbsp;</label>
                  <label class="cstm-check d-flex mt-2">
                    <input type="checkbox" v-model="newQuestion.is_required" />
                    <span class="checkmark"></span>
                    <span class="ms-4">Required</span>
                  </label>
                </div>
              </div>

              <div v-if="selectedLanguage">
                <div class="card mb-3">
                  <div class="card-header">
                    Question Text ({{
                      languages.find((l) => l.code === selectedLanguage)?.name
                    }})
                  </div>
                  <div class="card-body">
                    <div class="mb-2">
                      <input
                        v-model="newQuestion.translations[selectedLanguage]"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                <div v-if="newQuestion.type === 'selectable'" class="card">
                  <div
                    class="
                      card-header
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <span>Options</span>
                    <button
                      class="btn btn-sm btn-outline-primary"
                      @click="addQuestionOption"
                    >
                      Add Option
                    </button>
                  </div>
                  <div class="card-body">
                    <div
                      v-for="(option, index) in newQuestion.options"
                      :key="index"
                      class="border rounded p-3 mb-2 bg-light"
                    >
                      <div class="d-flex justify-content-between mb-2">
                        <span class="fw-bold">Option {{ index + 1 }}</span>
                        <button
                          class="btn btn-sm btn-link text-danger p-0"
                          @click="newQuestion.options.splice(index, 1)"
                        >
                          Remove
                        </button>
                      </div>
                      <div class="mb-2">
                        <label class="form-label small">{{
                          languages.find((l) => l.code === selectedLanguage)
                            ?.name
                        }}</label>
                        <input
                          v-model="option.translations[selectedLanguage]"
                          class="form-control form-control-sm"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                @click="showAddQuestion = false"
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="saveQuestion"
              >
                {{ editingQuestionId ? "Update" : "Save" }} Question
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OneByOneTable from "../lists/OneByOneTable.vue";
import http from "../../modules/http";

export default {
  name: "Returns",
  components: { OneByOneTable },
  data() {
    return {
      active: "return",
      euType: 1,
      partialEuType: 1,
      selectedLanguage: "",
      taxSettings: {},
      is_self_serve_return: 0,
      is_shop_return: 0,
      delete_return_delivery_days: 14,
      returnMethods: [],
      returnFormQuestions: [],
      returnFormQuestionRows: [
        {
          name: "Question",
          key: "question_text",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Type",
          key: "type",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Required",
          key: "is_required",
          type: "boolean",
          show: true,
          editable: false,
        },
      ],
      returnMethodRows: [
        {
          name: "Name",
          key: "name",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Need Bank Details",
          key: "need_bank_details",
          type: "boolean",
          show: true,
          editable: false,
        },
      ],
      showAddQuestion: false,
      editingQuestionId: null,
      newMethod: {
        translations: {},
        need_bank_details: false,
      },
      newQuestion: {
        type: "fillable",
        is_required: false,
        translations: {},
        options: [],
      },
      customerMenuItems: [
        {
          name: "Order status tracking",
          group: 1,
          enabled: true,
        },
        {
          name: "Variant change",
          group: 1,
          enabled: true,
        },
        {
          name: "Product change",
          group: 1,
          enabled: true,
        },
        {
          name: "Delete order",
          group: 1,
          enabled: true,
        },
        {
          name: "Return product",
          group: 1,
          enabled: true,
        },
        {
          name: "Address change",
          group: 1,
          enabled: true,
        },
        {
          name: "Help with something else",
          group: 1,
          enabled: true,
        },
        {
          name: "Report a complaint",
          group: 1,
          enabled: true,
        },
      ],
      customerMenuRows: [
        {
          name: "Option",
          key: "name",
          type: "enum",
          label: "name",
          selectKey: "id",
          values: [],
          show: true,
          editable: false,
        },
        {
          name: "Group",
          key: "group",
          type: "enum",
          label: "name",
          selectKey: "id",
          values: [
            { id: 1, name: "Manage order" },
            { id: 2, name: "Package pickup and delivery" },
            { id: 3, name: "Return" },
            { id: 4, name: "More" },
          ],
          show: true,
        },
        {
          name: "Enabled",
          key: "enabled",
          type: "boolean",
          show: true,
        },
      ],
    };
  },
  computed: {
    languages() {
      return this.$store.state.languages || [];
    },
    activeCountries() {
      return this.$store.state.countries || [];
    },
    exportCountries() {
      if (!this.activeCountries) return [];
      return this.activeCountries.filter((e) => !e.is_eu);
    },
    returnFormQuestionItems() {
      return this.returnFormQuestions.map((q) => {
        return {
          ...q,
          question_text: this.getQuestionTranslation(q, this.selectedLanguage),
        };
      });
    },
  },
  watch: {
    languages(newVal) {
      if (newVal && newVal.length > 0 && !this.selectedLanguage) {
        this.selectedLanguage = newVal[0].code;
      }
    },
    activeCountries: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // Initialize taxSettings for countries if not present
        }
      },
    },
    euType: {
      handler(newVal) {
        if (newVal && this.taxSettings) {
          Object.values(this.taxSettings).forEach((setting) => {
            if (setting.is_eu) {
              setting.return_mode = newVal;
            }
          });
        }
      },
    },
    partialEuType: {
      handler(newVal) {
        if (newVal && this.taxSettings) {
          Object.values(this.taxSettings).forEach((setting) => {
            if (setting.is_eu) {
              setting.partial_return_mode = newVal;
            }
          });
        }
      },
    },
  },
  created() {},
  mounted() {
    try {
      this.load();
    } catch (e) {
      console.error("Error in mounted calling load:", e);
    }
  },
  methods: {
    load() {
      try {
        http
          .fetch("/return-settings")
          .then((data) => {
            if (!data) {
              console.error("No data received from /return-settings");
              return;
            }
            this.is_self_serve_return = data.is_self_serve_return ? 1 : 0;
            this.is_shop_return = data.is_shop_return ? 1 : 0;
            this.delete_return_delivery_days =
              data.delete_return_delivery_days ?? 14;
            this.returnMethods = data.return_methods || [];
            this.returnFormQuestions = data.return_form_questions || [];

            if (data.company_tax_settings) {
              data.company_tax_settings.forEach((setting) => {
                this.taxSettings[
                  setting.country_id || (setting.is_eu ? "EU" : "OTHER")
                ] = {
                  id: setting.id,
                  return_mode: setting.return_mode ?? 0,
                  partial_return_mode: setting.partial_return_mode ?? 0,
                  is_eu: setting.is_eu,
                  country_id: setting.country_id,
                };
              });

              const euSetting = data.company_tax_settings.find((s) => s.is_eu);
              if (euSetting) {
                this.euType = euSetting.return_mode ?? 0;
                this.partialEuType = euSetting.partial_return_mode ?? 0;
              }
            }

            if (this.languages && this.languages.length > 0) {
              this.selectedLanguage = this.languages[0].code;
            }
          })
          .catch((err) => {
            console.error(
              "http.fetch('/return-settings') promise rejected:",
              err
            );
          });
      } catch (e) {
        console.error("Synchronous error in load() method:", e);
      }
    },
    saveSettings() {
      const taxSettingsData = Object.values(this.taxSettings).map((s) => {
        return {
          id: s.id,
          return_mode: s.return_mode,
          partial_return_mode: s.partial_return_mode,
        };
      });

      http.fetch(
        "/return-settings",
        {
          is_self_serve_return: this.is_self_serve_return,
          is_shop_return: this.is_shop_return,
          delete_return_delivery_days: this.delete_return_delivery_days,
          company_tax_settings: taxSettingsData,
        },
        true
      );
    },

    getQuestionTranslation(question, langCode) {
      if (!question || !question.translations) return "N/A";
      const translation = question.translations.find(
        (t) => t.language_code === langCode
      );
      return translation ? translation.question_text : "No translation";
    },
    getOptionTranslations(question, langCode) {
      if (!question || !question.options) return [];
      return question.options.map((opt) => {
        if (!opt || !opt.translations) return "N/A";
        const translation = opt.translations.find(
          (t) => t.language_code === langCode
        );
        return translation ? translation.option_text : "No translation";
      });
    },
    addQuestionOption() {
      this.newQuestion.options.push({ translations: {} });
    },
    openAddQuestion() {
      this.editingQuestionId = null;
      this.newQuestion = {
        type: "fillable",
        is_required: false,
        translations: {},
        options: [],
      };
      this.showAddQuestion = true;
    },
    editQuestionById(id) {
      const question = this.returnFormQuestions.find((q) => q.id === id);
      if (question) {
        this.editQuestion(question);
      }
    },
    editQuestion(question) {
      this.editingQuestionId = question.id;
      const translations = {};
      question.translations.forEach((t) => {
        translations[t.language_code] = t.question_text;
      });

      const options = (question.options || []).map((opt) => {
        const optTranslations = {};
        opt.translations.forEach((ot) => {
          optTranslations[ot.language_code] = ot.option_text;
        });
        return { translations: optTranslations };
      });

      this.newQuestion = {
        type: question.type,
        is_required: question.is_required ? true : false,
        translations: translations,
        options: options,
      };
      this.showAddQuestion = true;
    },
    saveQuestion() {
      const translations = Object.keys(this.newQuestion.translations)
        .filter((code) => this.newQuestion.translations[code])
        .map((code) => ({
          language_code: code,
          question_text: this.newQuestion.translations[code],
        }));

      if (translations.length === 0) {
        alert("Please provide at least one translation for the question.");
        return;
      }

      let options = [];
      if (this.newQuestion.type === "selectable") {
        options = this.newQuestion.options
          .map((opt) => {
            const optTranslations = Object.keys(opt.translations)
              .filter((code) => opt.translations[code])
              .map((code) => ({
                language_code: code,
                option_text: opt.translations[code],
              }));
            return { translations: optTranslations };
          })
          .filter((opt) => opt.translations.length > 0);

        if (options.length === 0) {
          alert("Please provide at least one option with a translation.");
          return;
        }
      }

      const payload = {
        type: this.newQuestion.type,
        is_required: this.newQuestion.is_required ? 1 : 0,
        translations: translations,
        options: options,
      };

      if (this.editingQuestionId) {
        http
          .fetch(
            `/return-form-questions/${this.editingQuestionId}`,
            payload,
            true,
            "PUT"
          )
          .then((data) => {
            const index = this.returnFormQuestions.findIndex(
              (q) => q.id === this.editingQuestionId
            );
            if (index !== -1) {
              this.returnFormQuestions.splice(index, 1, data);
            }
            this.showAddQuestion = false;
            this.editingQuestionId = null;
          })
          .catch((err) => {
            console.error("Error updating question:", err);
          });
      } else {
        http
          .fetch("/return-form-questions", payload, true)
          .then((data) => {
            this.returnFormQuestions.push(data);
            this.showAddQuestion = false;
          })
          .catch((err) => {
            console.error("Error adding question:", err);
          });
      }
    },
    addQuestion() {
      // Deprecated, using saveQuestion instead
      this.saveQuestion();
    },
    deleteQuestion(id) {
      if (confirm("Are you sure you want to delete this question?")) {
        http
          .fetch(`/return-form-questions/${id}`, {}, true, "DELETE")
          .then(() => {
            this.returnFormQuestions = this.returnFormQuestions.filter(
              (q) => q.id !== id
            );
          })
          .catch((err) => {
            console.error("Error deleting question:", err);
          });
      }
    },
    deleteQuestionById(question) {
      this.deleteQuestion(question.id);
    },
  },
};
</script>
